import swal from "sweetalert";
import axiosInstance from "../../../redux/api";

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const messageFromUploadError = (error) => {
  const d = error?.response?.data;
  if (!d) return error?.message || "Failed to upload image";
  if (typeof d.message === "string") return d.message;
  if (typeof d.response === "string") return d.response;
  return error?.message || "Failed to upload image";
};

export const uploadProductImage = async (file, { configType = "product", module = "product" } = {}) => {
  if (!file.type.startsWith("image/")) {
    await swal({ title: "Invalid File Type", text: "Please upload an image file", icon: "error" });
    throw new Error("Please upload an image file");
  }

  const maxSize = 5 * 1024 * 1024;
  if (file.size > maxSize) {
    await swal({ title: "File Too Large", text: "File size should be less than 5MB", icon: "error" });
    throw new Error("File size should be less than 5MB");
  }

  const base64 = await fileToBase64(file);

  try {
    const response = await axiosInstance.post("uploads/images", {
      file: base64,
      module,
      config_type: configType,
    });

    const data = response.data?.response || response.data;
    const urls = data?.urls || null;
    const url = data?.url || urls?.["800w"] || null;

    if (!urls || !url) {
      throw new Error("Upload response missing urls");
    }

    return { url, urls };
  } catch (error) {
    console.error("Product image upload failed:", error);
    await swal({ title: "Upload Failed", text: messageFromUploadError(error), icon: "error" });
    throw error;
  }
};

export const appendProductImageToFormik = async (file, formik, fieldName = "images") => {
  const { url, urls } = await uploadProductImage(file);
  const existing = Array.isArray(formik.values[fieldName]) ? formik.values[fieldName] : [];
  const next = [
    ...existing,
    { image_url: url, image_urls: urls, sort_order: existing.length },
  ];
  formik.setFieldValue(fieldName, next);
  return urls;
};

export const pickPreviewUrl = (image, preferredSize = "400w") => {
  if (!image) return null;
  if (typeof image === "string") return image;
  const urls = image.image_urls || image.urls;
  if (!urls) return image.image_url || null;
  return urls[preferredSize] || urls["800w"] || urls["400w"] || urls["200w"] || null;
};
